namespace $ { $mol_style_attach( "mol/book2/catalog/catalog.view.css",
 "[mol_book2_catalog_menu_filter] {\n\tflex-shrink: 0;\n\tflex-grow: 0;\n\talign-self: stretch;\n}\n\n"
) }